<template>
  <CContainer class="theMainSideBar p-0 bg-gray-100" fluid>
    <CRow>
      <CCol xs="12" sm="12" md="12" lg="3" xl="2" class="p-0 box-menu bg-white">
        <TheMenuSettings class="" />
      </CCol>
      <CCol xs="12" sm="12" md="12" lg="7" xl="8" class="px-3 ml-lg-5">
        <transition name="fade">
          <router-view></router-view>
        </transition>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import TheMenuSettings from './TheMenuSettings'

export default {
  name: 'TheMainSidebar',
  components: {
    TheMenuSettings,
  },
}
</script>

<style lang="scss" scoped>
.theMainSideBar {
}
.box-menu {
  min-height: 100vh;
  min-width: 320px;
  @media (min-width: 1260px) {
  }
}
.background-main {
  background-color: $light-gray;
}
</style>
